<template>
    <modal
        class="start-membership"
        :adaptive="true"
        width="620px"
        height="auto"
        name="start-membership"
    >
        <div class="close-modal" @click="$modal.hide('start-membership')">
            <img src="@assets/img/x-gray.svg" alt="X" width="20px">
        </div>
        <div class="start-membership-container">
            <img src="@assets/img/book-insights/icons/start-membership.svg" width="60" alt="Start Membership">
            <h1>Start membership for unlimited access</h1>
            <ul class="list-reset benefits-list">
                <li class="offer-badge">
                    <img src="@assets/img/book-insights/icons/offer-badge-icon.svg" width="22" alt="Offer Badge">
                    Sign-up now with 30-day money-back guarantee.
                </li>
                <li>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#19a98f" fill-rule="nonzero" d="M18.311 5.535a1.253 1.253 0 0 1 1.774-.004c.477.494.47 1.268-.014 1.752L9.483 17.87a1.255 1.255 0 0 1-1.769-.003l-4.182-4.182a1.252 1.252 0 0 1 0-1.771 1.25 1.25 0 0 1 1.757.02L8.6 15.247l9.711-9.71z" />
                    </svg>
                    <span>Unlimited access to all Book Insights</span>
                </li>
                <li>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#19a98f" fill-rule="nonzero" d="M18.311 5.535a1.253 1.253 0 0 1 1.774-.004c.477.494.47 1.268-.014 1.752L9.483 17.87a1.255 1.255 0 0 1-1.769-.003l-4.182-4.182a1.252 1.252 0 0 1 0-1.771 1.25 1.25 0 0 1 1.757.02L8.6 15.247l9.711-9.71z" />
                    </svg>
                    <span>All titles available as both text and audio</span>
                </li>
                <li>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#19a98f" fill-rule="nonzero" d="M18.311 5.535a1.253 1.253 0 0 1 1.774-.004c.477.494.47 1.268-.014 1.752L9.483 17.87a1.255 1.255 0 0 1-1.769-.003l-4.182-4.182a1.252 1.252 0 0 1 0-1.771 1.25 1.25 0 0 1 1.757.02L8.6 15.247l9.711-9.71z" />
                    </svg>
                    <span>Learn from the best nonfiction books in 30 minutes</span>
                </li>
            </ul>
            <div class="row w-100 mt-4">
                <div class="ml-auto col-12 col-md-8 mr-auto">
                    <router-link
                        tag="button"
                        type="button"
                        class="btn btn-block btn-primary"
                        :to="{ name: isLoggedIn ? 'subscription-book-insights' : 'bi-sign-up' }"
                    >
                        Start Membership
                    </router-link>
                </div>
            </div>
            <p v-if="!isLoggedIn" class="log-in-link mt-3 mb-0">
                Already have an account?
                <router-link :to="{ name: 'bi-sign-in' , query: { redirect: $route.path }}" class="text-primary font-weight-bold">
                    Sign In
                </router-link>
            </p>
        </div>
    </modal>
</template>

<script>

import { mapGetters } from "vuex";

export default {
    name: "SubscribeBi",
    computed: {
        ...mapGetters({
            isLoggedIn: "User/isLoggedIn"
        })
    }
}
</script>

<style lang="scss">
.start-membership {
    .close-modal {
        position: absolute;
        right: 20px;
        top: 15px;
        cursor: pointer;
    }

    .v--modal-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 60px 80px 40px 80px;
        border-radius: 20px;

        @media (max-width: $sm) {
            padding: 50px 10px 30px 10px;
        }

        .start-membership-container {
            display: flex;
            flex-direction: column;
            align-items: center;

            > img {
                margin-bottom: 15px;

                @media (max-width: $sm) {
                    width: 35px;
                }
            }

            h1 {
                color: white;
                font-family: "Gibson";
                font-size: 40px;
                font-weight: 600;
                line-height: 1.25;
                text-align: center;
                margin-bottom: 30px;

                @media (max-width: $sm) {
                    font-family: "Gibson";
                    font-size: 23px;
                    font-weight: 600;
                    font-style: normal;
                    line-height: 1.26;
                }
            }

            .benefits-list {
                background-color: #1b1b1b;
                border-radius: 6px;
                padding: 20px;

                .offer-badge {
                    color: white;
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 18px;
                    font-weight: 600;
                }

                li {
                    display: flex;
                    align-items: center;
                    padding: 10px 0;
                    padding-right: 10px;
                    font-size: 15px;
                    color: white;

                    img, svg {
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
</style>
